import axios from "axios";

export const ENV = process.env.REACT_APP_ENV;

export const isOAuthLoginEnabled =
  ENV === "PROD" || ENV === "UAT" ? true : false;

export const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_API}`,
});
